import React, { useState } from 'react';
import { Button, Col, Container, Row, Modal, Image } from 'react-bootstrap';
import { motion } from 'framer-motion';

// img
import PlayImg from '../../images/play-icon.svg';

export default function Video() {
    // Video modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <motion.section className='video-section' initial={{opacity: 0}} viewport={{once: true}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                <div className='video-bg-overlay'></div>
                <Container className='position-relative'>
                    <Row className='align-items-center'>
                        <Col lg={8} xl={7} xxl={6}>
                            <motion.h1 className='display-5 fw-medium text-white' initial={{opacity: 0 ,x: -50}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}}>Food is not just eating energy. It's an experience.</motion.h1>
                            <motion.p className='text-white opacity-80 mt-4' initial={{opacity: 0 ,x: -50}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}}>At our restaurant, every dish is crafted with passion, blending flavors that excite your taste buds and leave a lasting impression. We believe that a meal should be more than just sustenance; it should be a journey that engages all your senses, from the first aroma to the final bite.</motion.p>
                            <motion.p className='text-white opacity-80 my-4' initial={{opacity: 0 ,x: -50}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}}>Whether you're savoring a comforting classic or exploring something new, our dishes are designed to create memorable moments. </motion.p>
                            <motion.h5 className='text-white fs-20 d-flex align-items-center gap-3 mb-0' initial={{opacity: 0 ,x: -50}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}}>Watch Our Story <span className='fs-30'>→</span></motion.h5>
                        </Col>
                        <Col lg={4} xl={5} xxl={6} className='text-center mt-5 mt-lg-0 pt-5 pt-lg-0'>
                            <motion.div className='play-btn' initial={{opacity: 0 ,x: 50}} whileInView={{opacity: 1, x: 0}} transition={{duration: 0.5}}>
                                <Button variant="danger" onClick={handleShow}>
                                <Image src={PlayImg} alt="" className='play-icon' />
                                </Button>
                                <div className="waves-block">
                                    <div className="waves wave-1"></div>
                                    <div className="waves wave-2"></div>
                                    <div className="waves wave-3"></div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </motion.section>

            {/* Video Modal */}
            <Modal show={show} size="lg" onHide={handleClose} centered className='video-modal'>
                <Modal.Header className='p-0' closeButton></Modal.Header>
                <Modal.Body className='p-0'>
                    <div className="ratio ratio-16x9">
                        <iframe
                            className='d-block'
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/--MdohXec7M?si=ubCj-rKlhqHrlTFj&controls=1"
                            title="Experience Culinary Art - Our Restaurant Video"
                            frameBorder="0"
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
